{
  "menu_title": "O Nosso Menu",
  "product_details": "Detalhes do produto",
  "example_photo_label": "Foto de exemplo",
  "example_photo_notice": "Fotografia de exemplo. O produto varia consoante as tuas escolhas.",
  "menu_subtitle": "Escolhe uma categoria, personaliza e confirma quando estiver tudo pronto.",
  "welcome_title": "Bem-vindo ao Bamidi!",
  "welcome_question": "Como te podemos chamar?",
  "welcome_placeholder": "O teu nome…",
  "welcome_start": "Começar",
  "welcome_customer": "Olá, {{name}}!",
  "table": "Mesa",
  "customise": "Personalizar",
  "filter_all": "Todos",
  "search_placeholder": "Pesquisar...",
  "cart_items": "Itens",
  "items_count_one": "{{count}} item",
  "items_count_other": "{{count}} itens",
  "options_count_one": "{{count}} opção",
  "options_count_other": "{{count}} opções",
  "view_order": "VER PEDIDO",
  "view_cart": "Ver carrinho",
  "loading": "A carregar menu...",
  "add_to_cart": "Adicionar",
  "open_cart": "Abrir carrinho",
  "cart_accessible_one": "Abrir carrinho, {{count}} item, total {{total}}",
  "cart_accessible_other": "Abrir carrinho, {{count}} itens, total {{total}}",
  "added_to_cart": "{{product}} adicionado ao carrinho.",
  "price": "Preço",
  "ingredients": "Ingredientes",
  "loading_sweetness": "A preparar doçura...",
  "filter_vegan": "Vegan",
  "filter_vegetarian": "Vegetariano",
  "filter_gluten_free": "Sem Glúten",
  "checkout_title": "Finalizar Pedido",
  "empty_cart": "O carrinho está vazio",
  "app_title": "Bamidi Beach Bar",
  "status_waiting": "A aguardar confirmação",
  "status_confirmed": "Confirmado",
  "status_preparing": "Em preparação",
  "status_ready": "Pronto / Entregue",
  "status_cancelled": "Cancelado / Recusado",
  "suggestions_title": "Vai acompanhar com...?",
  "total": "Total",
  "send_to_kitchen": "Finalizar Pedido",
  "order_received": "Pedido Recebido!",
  "order_sent_message": "Recebemos o pedido #{{id}} da Mesa {{table}}. Pode acompanhar o estado abaixo.",
  "track_order": "Acompanhar Pedido",
  "active_orders_one": "{{count}} pedido ativo",
  "active_orders_other": "{{count}} pedidos ativos",
  "active_orders_title": "Pedidos ativos",
  "your_orders": "Os teus pedidos",
  "back_to_menu": "Voltar ao Menu",
  "msg_pending": "A aguardar confirmação…",
  "msg_preparing": "Os chefs estão a preparar as tuas delícias!",
  "msg_ready": "Tudo pronto! Está a chegar à tua mesa.",
  "back": "Voltar",
  "order_number": "Pedido #{{id}}",
  "refresh": "Atualizar",
  "label_track": "Acompanhar",
  "my_active_orders": "Meus Pedidos Ativos",
  "my_order_history": "Histórico de Pedidos",
  "no_active_orders": "Nenhum pedido ativo.",
  "no_history_orders": "Nenhum pedido anterior.",
  "view_history": "Ver Histórico",
  "view_active": "Ver Ativos",
  "close": "Fechar",
  "my_orders_count": "Meus Pedidos ({{count}})",
  "error_pending_order": "Já tens pedidos pendentes. Aguarda a confirmação antes de fazer um novo pedido.",
  "order_error": "Não foi possível enviar o pedido. Tente novamente.",
  "error_scan_qr": "Leia novamente o código QR da mesa para fazer o pedido.",
  "table_session_expired": "A sessão da mesa expirou após 30 minutos de inatividade. Leia novamente o código QR da mesa. O seu carrinho foi guardado.",
  "menu_load_error": "Não foi possível carregar o menu.",
  "retry": "Tentar novamente",
  "categories": "Categorias",
  "options": "opções",
  "menu_navigation": "Navegação do menu",
  "featured_section": "Mais pedidos",
  "featured": "Mais pedido",
  "no_filter_results": "Nenhum produto corresponde aos filtros",
  "no_filter_results_hint": "Experimenta remover um filtro ou escolher outra categoria.",
  "clear_filters": "Limpar filtros",
  "allergens": "Alergénios",
  "modifier_choose_one": "Escolha 1",
  "modifier_choose_min": "Escolha pelo menos {{count}}",
  "modifier_choose_up_to": "Até {{count}}",
  "modifier_optional": "Opcional",
  "modifier_category_toppings": "Toppings e extras",
  "modifier_category_fruit": "Fruta",
  "fruit_bundle_price": "Até 3 frutas: {{first}} · 4 ou mais: {{more}}",
  "modifier_category_decoration": "Decoração",
  "modifier_category_ice_cream": "Sabores de gelado",
  "modifier_category_drink_flavour": "Sabor",
  "ice_cream_scoops": "Bolas de gelado",
  "extra_scoops": "Bolas extra",
  "no_extra_scoops": "Sem bolas extra",
  "included_scoops_one": "{{count}} bola incluída",
  "included_scoops_other": "{{count}} bolas incluídas",
  "choose_each_flavour": "Sabor de cada bola",
  "scoop_count_one": "{{count}} bola",
  "scoop_count_other": "{{count}} bolas",
  "scoop_flavour": "Bola {{count}}",
  "choose_flavour": "Escolher sabor",
  "choose_flavour_for_each_scoop": "Escolha um sabor para cada bola de gelado.",
  "modifier_category_sauces": "Molhos",
  "quantity": "Quantidade",
  "decrease_quantity": "Diminuir quantidade",
  "increase_quantity": "Aumentar quantidade",
  "modifier_required_missing": "Faltam escolhas obrigatórias:",
  "order_note_label": "Alguma indicação?",
  "order_note_placeholder": "Ex.: sem açúcar, alergia a frutos secos…",
  "kitchen_closed": "Cozinha fechada",
  "cafe_closed": "Café fechado",
  "hot_drinks_photo_notice": "As fotografias das bebidas quentes são genéricas e meramente ilustrativas.",
  "recommendations_section": "As nossas recomendações",
  "payment_method": "Método de pagamento",
  "payment_choose_hint": "Escolhe a opção disponível para confirmar o teu pedido.",
  "payment_select": "Escolher este método",
  "payment_app": "Pagar na app",
  "payment_unavailable": "Temporariamente indisponível",
  "payment_app_unavailable_hint": "Pedimos desculpa, esta opção encontra-se temporariamente indisponível.",
  "recommendations_short": "Recomendações",
  "categories_all": "Ver todas as categorias",
  "payment_title": "Como deseja pagar?",
  "sending_order": "A enviar…",
  "order_send_error": "Não foi possível confirmar o envio. Tenta novamente; o mesmo pedido não será duplicado.",
  "payment_counter": "Pagamento no ato de entrega dos produtos",
  "payment_counter_hint": "Dinheiro ou cartão.",
  "sold_out": "Esgotado",
  "language": "Idioma",
  "allergen_aipo": "Aipo",
  "allergen_amendoins": "Amendoins",
  "allergen_gluten": "Cereais que contêm glúten",
  "allergen_crustaceos": "Crustáceos",
  "allergen_sulfitos": "Dióxido de enxofre e sulfitos",
  "allergen_frutos-casca-rija": "Frutos de casca rija",
  "allergen_leite": "Leite",
  "allergen_moluscos": "Moluscos",
  "allergen_mostarda": "Mostarda",
  "allergen_ovos": "Ovos",
  "allergen_peixes": "Peixes",
  "allergen_sesamo": "Sementes de sésamo",
  "allergen_soja": "Soja",
  "allergen_tremoco": "Tremoço",
  "choice_decoration": "Decoração",
  "choice_fruit": "Fruta",
  "choice_toppings": "Coberturas",
  "choice_sauces": "Molhos",
  "choice_drink_flavour": "Sabor da bebida",
  "choice_extras": "Extras",
  "choice_ice_cream_flavour": "Sabor do gelado",
  "choice_ice_cream_flavours": "Sabores do gelado",
  "staff_bell_hint": "Precisas de ajuda? Toca no sino para chamar um funcionário.",
  "staff_bell_hint_close": "Fechar dica do sino",
  "staff_help": "Ajuda à mesa",
  "call_staff": "Chamar funcionário",
  "staff_call_checking": "A verificar chamada…",
  "staff_call_sending": "A chamar…",
  "staff_call_pending": "Funcionário chamado",
  "staff_call_offline": "Sem rede para chamar",
  "staff_call_sent": "O funcionário foi chamado para a mesa {{table}}. Aguarda um momento.",
  "staff_call_resolved": "A tua chamada foi atendida. Podes voltar a chamar se precisares de ajuda.",
  "staff_call_error": "Não foi possível confirmar a chamada. Verifica a ligação e tenta novamente.",
  "staff_call_table": "Mesa {{table}}",
  "add_to_order": "Adicionar ao pedido",
  "choose_required_options": "Escolher opções",
  "tracking_loading": "A carregar o estado do pedido…",
  "tracking_error": "Não foi possível atualizar o estado do pedido. Tente novamente.",
  "status_delivered": "Entregue",
  "brand_description": "Gelataria & creparia",
  "skip_to_menu": "Saltar para o menu",
  "menu_load_error_hint": "Verifica a ligação e tenta carregar o menu novamente."
}
